import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { OperatorEnum } from '@y42/json-schema';
import { AgFilterComponent } from 'ag-grid-angular';
import { AgPromise, IAfterGuiAttachedParams, IFilterParams } from 'ag-grid-community';
import { merge, tap } from 'rxjs';
import { OperationInputComponent } from '../operation-input/operation-input.component';
import { OperationInputColumn } from '../operation-input/operation-input.model';

@UntilDestroy()
@Component({
  selector: 'y42-operation-input-ag-filter',
  templateUrl: './operation-input-ag-filter.component.html',
  styleUrls: ['./operation-input-ag-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInputAgFilterComponent implements AgFilterComponent, AfterViewInit {
  @ViewChild(OperationInputComponent) operationInputComponent?: OperationInputComponent;

  private params?: IFilterParams;
  private hidePopup?: () => void;

  private get form() {
    return this.operationInputComponent?.form;
  }

  column!: OperationInputColumn;

  agInit(params: IFilterParams<unknown>): void {
    this.params = params;
    // TODO type
    this.column = params.colDef.headerComponentParams.dataColumn;
  }

  refresh(params: IFilterParams<unknown>): void {
    this.params = params;
  }

  ngAfterViewInit() {
    if (this.operationInputComponent) {
      merge(this.operationInputComponent.appliedOperations, this.operationInputComponent.resetOperations)
        .pipe(
          tap(() => {
            this.params?.filterChangedCallback();
            this.hidePopup?.();
          }),
          untilDestroyed(this),
        )
        .subscribe();
    }
  }

  afterGuiAttached(params?: IAfterGuiAttachedParams) {
    if (params && params.hidePopup) {
      this.hidePopup = params.hidePopup;
    }
  }

  isFilterActive(): boolean {
    return this.form?.dirty ?? false;
  }

  doesFilterPass(): boolean {
    return false;
  }

  getModel() {
    if (!this.operationInputComponent) {
      return null;
    }

    const operations = this.operationInputComponent.getOperations();
    return operations.length
      ? {
          variable_type: this.column!.data_type,
          operations,
        }
      : null;
  }

  setModel(model: { type: 'equals' | 'blank'; values: unknown[] } | null): void | AgPromise<void> {
    if (!this.form) {
      return;
    }

    if (!model) {
      // reset
      this.operationInputComponent?.reset();
      return;
    }

    const operationsFormArray = this.form.controls.operations;
    const operationControl = operationsFormArray.controls[0];

    if (!operationControl) {
      return;
    }

    const value = model.values?.[0];

    if (model.type === 'blank' || value === null || value === undefined) {
      this.operationInputComponent?.writeValue([
        {
          ...operationControl.value,
          operator: OperatorEnum.IsEmpty,
          values: [],
        },
      ]);
    } else {
      this.operationInputComponent?.writeValue([
        {
          ...operationControl.value,
          operator: OperatorEnum.Equals,
          values: [value],
        },
      ]);
    }

    this.form.markAsDirty();
  }
}
